import { atom } from 'jotai';
import {CategoryInterface, DepartmentInterface} from "./interfaces.ts";

export const matchingClientsAtom = atom<number>(0);

export const categoriesAtom = atom<Array<CategoryInterface>>([]);

export const departmentsAtom = atom<Array<DepartmentInterface>>([]);

export const selectedDepartmentsAtom = atom<Array<string>>([]);